import { render, staticRenderFns } from "./InfoColumnHeader.vue?vue&type=template&id=400f3942&"
import script from "./InfoColumnHeader.vue?vue&type=script&lang=ts&"
export * from "./InfoColumnHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InfoColumnHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports